import React, { useContext, useEffect, useState } from 'react'
import AuthContext from '../context/AuthContext';
import { withRouter, generatePath } from "react-router-dom";
import history from '../history';

import Button from 'react-bootstrap/esm/Button';
import Container from 'react-bootstrap/esm/Container';
import { Card, Row, Col } from 'react-bootstrap';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Modal from 'react-bootstrap/Modal';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import Collapsible from 'react-collapsible';
import { ListManager } from 'react-beautiful-dnd-grid';
import LoadingOverlay from 'react-loading-overlay';
import Switch from "react-switch";

const ComparePhotoPage = () => {
    let { isAuthenticated, authTokens, user, url } = useContext(AuthContext)

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [isActive, setIsActive] = useState(false)

    const [showToast, setShowToast] = useState(false);

    const [fullscreenImage, setFullscreenImage] = useState(null);

    const openFullscreen = (image) => {
        setFullscreenImage(image);
    };

    const closeFullscreen = () => {
        setFullscreenImage(null);
    };

    const [patient_1, setPatient_1] = useState(null)
    const [patient_2, setPatient_2] = useState(null)
    const [id, setId] = useState(null)

    let getImages = async () => {
        setIsActive(true)
        let response = await fetch('https://breloai-backend.inesctec.pt/api/comparePhotos/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            },
        })
        let data = await response.json()
        if (response.status === 200) {
            setPatient_1(data["patient_1_image_path"])
            setPatient_2(data["patient_2_image_path"])
            setId(data["id"])
        }
        else {
        }
        setIsActive(false)
    }

    let handleSubmit = async (choice) => {

        let response = await fetch('https://breloai-backend.inesctec.pt/api/comparePhotos/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            },
            body: JSON.stringify({ "choice": choice, "id": id })
        })
        if (response.status === 200) {
            getImages()
        }
        else if (response.status === 202) {
        }

    }

    useEffect(() => {
        getImages()
    }, [])

    return (
        <Container style={{ minWidth: '100vw' }}>
            <Breadcrumb>
                <Breadcrumb.Item onClick={() => history.push(generatePath("/"))}>Dashboard</Breadcrumb.Item>
                <Breadcrumb.Item active>
                    Morphing Page
                </Breadcrumb.Item>
            </Breadcrumb>

            <ToastContainer className="mt-5" position="top-center">
                <Toast onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide bg='success'>
                    <Toast.Header>
                        <strong className="me-auto">Download Successful</strong>
                    </Toast.Header>
                    <Toast.Body>
                        Go to the '/media/csvs' in the CINDERELLA NAS.
                    </Toast.Body>
                </Toast>
            </ToastContainer>

            {
                user.is_staff ?
                    <Container>
                        <div className='addPatient-div'>
                            <Button variant="outline-primary" className="addPatient-button" onClick={() => console.log("yo")}><i className="fa fa-download" aria-hidden="true"></i> Download Compare Photos Data</Button>
                        </div>
                    </Container> :
                    null
            }

            <div style={{ display: "flex", alignItems: "center", justifyContent: 'center', margin: '2vw' }}>
                <span style={{ display: "flex", alignItems: "center", justifyContent: 'center', marginRight: '1vw' }}>Which aesthetic outcome is better?</span>
            </div>
            
            <LoadingOverlay active={isActive} spinner>
                <Row className="responsiveRow">
                    <Col>
                        <Row className='mb-4' style={{ display: "flex", alignItems: "center", justifyContent: 'center', }}>
                            <Card className="text-center cardMorphing" style={{ width: '20vw' }}>
                                <Card.Header style={{ backgroundColor: "white" }}>Patient 1</Card.Header>
                                <Card.Img onClick={(e) => openFullscreen(e.target.src)} variant="top" src={patient_1 === null ? 'https://breloai-backend.inesctec.pt/media/default.jpeg' : 'https://breloai-backend.inesctec.pt' + patient_1} width="250" height="250" />
                            </Card>
                        </Row>
                        <Row className='mb-4' style={{ display: "flex", alignItems: "center", justifyContent: 'center', }}>
                            <Button variant="outline-primary morphingButton" className="addPatient-button" onClick={() => handleSubmit(1)}><i className="fa fa-check" aria-hidden="true"></i> Select</Button>
                        </Row>
                    </Col>
                    <Col>
                        <Row className='mb-4' style={{ display: "flex", alignItems: "center", justifyContent: 'center', }}>
                            <Card className="text-center cardMorphing" style={{ width: '20vw' }}>
                                <Card.Header style={{ backgroundColor: "white" }}>Patient 2</Card.Header>
                                <Card.Img onClick={(e) => openFullscreen(e.target.src)} variant="top" src={patient_2 === null ? 'https://breloai-backend.inesctec.pt/media/default.jpeg' : 'https://breloai-backend.inesctec.pt' + patient_2} width="250" height="250" />
                            </Card>
                        </Row>
                        <Row className='mb-4' style={{ display: "flex", alignItems: "center", justifyContent: 'center', }}>
                            <Button variant="outline-primary morphingButton" className="addPatient-button" onClick={() => handleSubmit(2)}><i className="fa fa-check" aria-hidden="true"></i> Select</Button>
                        </Row>
                    </Col>
                </Row>
            </LoadingOverlay>


            {fullscreenImage && (
                <div
                    className="fullscreen-overlay"
                    onClick={closeFullscreen}
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0, 0, 0, 0.9)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999,
                        cursor: "pointer",
                    }}
                >
                    <img
                        src={fullscreenImage}
                        alt="Fullscreen View"
                        style={{
                            maxWidth: "90%",
                            maxHeight: "90%",
                            objectFit: "contain",
                        }}
                    />
                </div>
            )}

        </Container >

    )
}

export default withRouter(ComparePhotoPage)